export default __webpack_public_path__ + "images/1ec3a9e7dbd895ac94d802ab2ee83a4f-food_and_drink_desktop-2.webp";